const PG_LIST = [
  'Inicis',
  'Kicc',
  'Nice',
  'Paypal',
  'Stripe'
]

const req = require.context('./', false, /\.vue$/)

const registry = Object.create(null)

req.keys().forEach((k) => {
  const name = k.replace('./', '').replace('.vue', '')

  if (!PG_LIST.includes(name)) return

  const mod = req(k)
  registry[name] = mod.default || mod
})

export function getPaymentComponent(pg) {
  if (!pg) return null

  const name = String(pg).replace(/\b\w/g, l => l.toUpperCase())

  return registry[name] || null
}